module.exports = __webpack_public_path__ + "static/media/symptoms-vitals-and-lifestyle-tracking-02.44ab53e8.png";